/**
 * Handle Details workflow interface
 */
const $inject = [
  "PharmacistService",
  "MessageService",
  "CommonData",
];

class DetailsController {
  constructor(
    PharmacistService,
    MessageService,
    CommonData
  ) {
    this.pharmacist = {};

    this.states = CommonData.STATES;
    this.titles = CommonData.TITLES;

    // Components
    /** @var {PharmacistService} */
    this.PharmacistService = PharmacistService;
    /** @var {MessageService} */
    this.MessageService = MessageService;

    this.updatePA = {
      updateSuccess: false,
      error: false,
      message: "",
    };

    this.validationMessage = {};

    // Initialisation
    this.get();

    // Entities
    this.account = {};
  }

  /**
   * Get pharmacist details
   */
  get() {

    var self = this;

    var handleSuccess = function (response) {
      if (!response.data.error) {
        self.loading = false;
        self.pharmacist = response.data.data.account;
      }
      else {
        handleError(response);
      }
    };

    var handleError = function (response) {
      //TODO define behaviour
      self.loading = false;
    };

    this.loading = true;
    this.PharmacistService.get(handleSuccess, handleError);
  }

  /**
   * Update user details
   */
  update(form) {
    this.submitted = true;
    this.updateForm = form;
    this.updateForm.validationMessage = null;

    var self = this;
    //FIXME: Stops messages from appearing!?
    // self.MessageService.clearAll();

    var handleSuccess = function (response) {
      self.MessageService.clearAll();

      if (!response.data.error) {
        self.loading = false;
        self.updatePA.updateSuccess = true;
        self.updatePA.error = false;
        self.updatePA.message = response.data.message;
        self.MessageService.add("success", "Profile successfully updated");
        if (window.scrollTo) {
          window.scrollTo(0, 0);
        }
      }
      else {
        handleError(response);
      }
    };

    var handleError = function (response) {
      self.MessageService.clearAll();

      self.loading = false;
      self.updatePA.updateSuccess = false;
      self.updatePA.error = true;
      self.validationMessage = response.data.message;
      self.updateForm.validationMessage = response.data.message;
      //Set the form back to untouched, as though we just loaded it again
      self.updateForm.$setPristine();

      for (var element in response.data.message) {
        if (self.updateForm[element]) {
          self.updateForm[element].$setValidity("server", false);
        }
      }
      self.updatePA.message = response.data.message;
      if (response.data.message) {
        var messageStr = "Could not update details. Please review the errors below. ";
        self.MessageService.add("danger", messageStr);
      }
      else {
        self.MessageService.add("danger", "An error has occurred with submission all details may not have been saved.");
      }
      if (window.scrollTo) {
        window.scrollTo(0, 0);
      }
    };

    if (form.$valid) {
      this.loading = true;
      this.PharmacistService.update(self.pharmacist, handleSuccess, handleError);
    }
  }

  changeEvent(formElement) {
    formElement.$setValidity("server", true);
  }
}

DetailsController.$inject = $inject;

export default DetailsController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/pharmacist/controllers/details.controller.js
 **/